var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading d-flex justify-content-center align-items-center"},[(_vm.showloadingicon)?_c('div',{staticClass:"icon"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }